import { useSelector } from "react-redux";
import { info } from "../../../texts/fill";

const ErrorsInfo = () => {
    const error = useSelector(state => state.error);
    if (!error) return null;

    return (
        <div
            className="alert alert-danger"
            role="alert"
            style={{ width: "158px", height: "130px", margin: '0', padding: '6px' }}
        >
            {info}
        </div>
    );
};

export default ErrorsInfo;